import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import DataLoader from '../component/DataLoader'; 
import { AuthContext } from '../context/Auth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <DataLoader />;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
